import React from "react";
import PropTypes from 'prop-types';
import { ProgressSurveyQuestion } from "../utils/types";
import css from "./MobileQuestionDefinitionView.css";
import Modal from 'react-modal';
import QuestionDefinitionsList from './QuestionDefinitionsList';
import QuestionDefinitionsCloseButton from './QuestionDefinitionsCloseButton';

export default class MobileQuestionDefinitionView extends React.Component {

  constructor() {
    super();
    Modal.setAppElement(document.getElementById('main-center'));
    this.closeButtonRef = React.createRef();
  }

  afterOpenModal() {
    this.closeButtonRef.current.focus();
  }

  render() {
    if ( window.innerWidth > 768 ) return null;
    return (
      <Modal
        isOpen={this.props.open}
        onRequestClose={this.props.onClose}
        onAfterOpen={this.afterOpenModal.bind(this)}
        className={css['modal']}
        contentLabel={"Column Information Modal"}>
        <QuestionDefinitionsCloseButton ref={this.closeButtonRef} onClick={this.props.onClose}/>
        <QuestionDefinitionsList surveyQuestions={this.props.surveyQuestions}/>
      </Modal>
    )
  }
}

MobileQuestionDefinitionView.propTypes = {
  surveyQuestions: PropTypes.arrayOf(ProgressSurveyQuestion),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}
